import { Injectable } from '@angular/core';
import { AppConfigService, constants, FEATURE_FLAGS, HybridAppService } from '@edassist/common';
import { LocalStorageService } from '@tuition/app/core/services/local-storage/local-storage.service';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class WelcomePageGuard {

	constructor(private readonly router: Router, private readonly hybridAppService: HybridAppService) {
	}

	canActivate(): boolean {
		const clientId = LocalStorageService.getItem(constants.localStorageKeys.CLIENT_DETAILS)?.clientId;
		const isNewLandingPageEnabled = AppConfigService.isNewLandingPageEnabled(clientId);
		const isNewLoginUIEnabled = AppConfigService.featureFlagForClientIds(FEATURE_FLAGS.NEW_LOGIN_UI_ENABLED, clientId);
		if (isNewLoginUIEnabled) {
			this.hybridAppService.navigateToLoginUI();

			return false;
		} else if (isNewLandingPageEnabled) {

			return true;
		} else {
			// Redirect to home page if new landing page is not enabled
			this.router.navigate([constants.routes.home]);

			return false;
		}
	}
}
